import { TeamType } from './TeamType';

const teamTypeToName: Record<TeamType, string> = {
  [TeamType.STARTER]: 'Starter',
  [TeamType.PRO]: 'Pro',
  [TeamType.MASTER]: 'Master',
  [TeamType.EDU_STARTER]: 'EduStarter',
  [TeamType.EDU_PRO]: 'EduPro',
  [TeamType.EDU_EXPERT]: 'Expert',
  [TeamType.EDU_GENIUS]: 'Genius',
  [TeamType.EDU_360]: 'Edu360',
  [TeamType.STUDENT_PRO]: 'StudentPro',
  [TeamType.AUTHOR]: 'Author',
  [TeamType.ENTERPRISE]: 'Enterprise',
  [TeamType.EDU_CAMPUS]: 'Campus',
};

export const getPlanName = (plan: TeamType): string => teamTypeToName[plan];
